<template>
    <div class="row">
        <div class="col-md-6">
            <div class="user-chats">
                <div class="chats">
                    <ul class="nav nav-tabs">
                        <li class="nav-item"> <span @click="getProducts(-1)" class="nav-link cursor-pointer">All</span> </li>
                        <li v-for="(item, index) in items" :key="index" class="nav-item">
                            <span
                              @click="getProducts(item.id)"
                              class="nav-link cursor-pointer"
                            >
                                {{ item.name }}
                            </span>
                        </li>
                        <li v-if="items.length > 2" class="nav-item"> <span class="nav-link">More</span> </li>
                    </ul>

                    <div class="row p-2">
                        <div v-for="(item, index) in products" :key="index" class="col-4 cursor-pointer" @click="addItem(item)">
                            <img :src="item.description && 
                                item.description.image ? 
                                item.description.image :
                                `/app-assets/images/product-photo.png`" 
                                class="image-width"/>
                            <p>{{ item.name }}</p> 
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="d-flex justify-content-between">
                <h4>TOTAL BILL AMOUNT = </h4>
                <h4> 
                    <vField
                        v-model="totalAmount"
                        readonly
                        name="total_amount"
                        type="number"
                        class="form-control text-right"
                    >  
                    </vField>
                </h4>
            </div>
            <div class="table-container mb-20">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Qty</th>
                            <th class="text-right">Price</th>
                            <th class="text-right">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in data" :key="index">
                            <th class="text-overflow">{{ item.name }}</th>
                            <th class="text-right">
                                <input
                                    v-model="item.quantity"
                                    name="quantity"
                                    type="number"
                                    class="form-control text-right p-0"
                                    @input="changeQty(item.quantity, index)"
                                /> 
                            </th>
                            <th class="text-right">
                                <input
                                    v-model="item.rate"
                                    name="quantity"
                                    type="number"
                                    class="form-control text-right p-0"
                                /> 
                            </th>
                            <th class="text-right px-0">
                                <input
                                    type="text"
                                    class="form-control text-right p-0"
                                    :value="item.rate * item.quantity"
                                    readonly
                                />
                            </th>
                            <th><span class="cursor-pointer" @click="deleteTableItem(index)">X</span></th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pay-now">
                <h4 class="p-1 pay">Pay Now</h4>
            </div>
            <div class="d-flex mt-2">
                <div class="col-6 p-1">
                    <label for="colFormLabel" class="col-form-label">Received in</label>
                    <v-select
                        placeholder="Select Cash & Bank Account"
                        class="w-100"
                        v-model="formData.mop_account_head_id"
                        :options="cashAndBank"
                        label="name"
                        :reduce="name => name.id"
                    />
                    <input v-model="formData.receipt_reference" type="text" class="form-control mt-1" placeholder="MoP Reference"/>
                </div>
                
                <div class="col-6 p-1">
                    <div class="d-flex justify-content-between mb-2">
                        <label class="form-label" for="total_amount">Total Amount</label>
                        <vField
                            v-model="totalAmount"
                            readonly
                            name="total_amount"
                            type="number"
                            class="form-control text-right"
                        />
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <label class="form-label" for="discount-percent">Discount Percent</label>
                        <vField
                            v-model="discountPercent"
                            name="discount-percent"
                            type="number"
                            class="form-control text-right"
                            max="100"
                            min="0"
                        />
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <label class="form-label" for="discount-amount">Discount Amount</label>
                        <vField
                            v-model="discountAmount"
                            name="discount-amount"
                            type="number"
                            class="form-control text-right"
                            min="0"
                        />
                    </div>
                    <div v-if="discountAmount > 0" class="d-flex justify-content-between mb-2">
                        <label class="form-label" for="discount-amount">Select Discount Head</label>
                        <v-select
                            placeholder="Select Discount Head"
                            v-model="formData.discount_head_id"
                            :options="discountAccHead"
                            label="name"
                            :reduce="name => name.id"
                        />
                    </div>
                    <div class="button mt-3">
                        <vField
                            v-model="grandTotal"
                            readonly
                            name="total_amount"
                            type="number"
                            class="form-control text-right"
                        >  
                        </vField>
                        <button class="btn btn-primary w-100 mt-2" @click="submitData">
                            Save & Print
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-2 position-absolute bottom-0">
            <Pagination
                :offset="20"
                @onPageChange="onPageChange"
                ref="pagination"
            />
        </div>
    </div>

</template>

<script setup>
import { ref, reactive, watch, onMounted, computed, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Pagination from '@/components/atom/Pagination';
import { generateTxnNumber } from '@/services/utils/voucherNumberGenerator';
import handlePurchase from '@/services/modules/purchase';
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleBarcode from '@/services/modules/barcode';
import figureFormatter from '@/services/utils/figureFormatter';
import handleCompany from '@/services/modules/company';
import handleReceipt from '@/services/modules/receipt'

const props = defineProps({
  items: Array,
  contactProfileId: null,
  companyId: null,
  locationId: null,
  productId: null,
});

const emit = defineEmits(['resetIds']);

const store = useStore();
const route = useRoute();
const router = useRouter();

const products = ref([]);
const data = ref([]);
const voucher = ref('');
const discountAmount = ref(0);
const discountPercent = ref(0);
const companyInfo = ref({});
const cashAndBank = ref([]);
const discountAccHead = ref([]);
const accountRecHead = ref([]);

const showError = inject("showError");
const showSuccess = inject("showSuccess");

const { fetchCompanyInfo } = handleCompany();
const { fetchSalesBill, ...rest } = handlePurchase();
const { fetchCashAndBank } = handleReceipt();

const formData = reactive({
  company_id: null,
  contact_profile_id: null,
  account_head_id: null,
  mop_account_head_id: null,
  business_id: null,
  project_id: null,
  cost_centre_id: null,
  location_id: null,
  status: 'active',
  bill_number: '',
  date: '',
  has_item_detail: true,
  description: '',
  order_number: null,
  sales_person_id: null,
  commission_percent: null,
  lc_number: null,
  discount_amount: 0,
  discount_percent: 0,
  discount_head_id: null,
  discount_account_head_id: null,
  vat_amount: 0,
  sale_type: 'pos_invoice',
  receipt_type: 'pos_invoice',
  receipt_reference: '',
  item_details: [{
    product_id: null,
    name: '',
    description: '',
    quantity: 1,
    rate: 0,
    discount_percent: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
  }]
});

onMounted(() => {
    getProducts();
    getVoucher();
    getAccountData();
});

async function submitData() {
  organizeData();
  const handler = handlePurchase();
  const copyFormData = { ...formData };
  copyFormData.item_details = data.value;
  copyFormData.sale_master_receipt = true;
  try {
    const res = await handler.storeBillPayment(copyFormData);

    if(! res.status ) {
        showError(res.message);
        return;
    }

    showSuccess(res.message)
    goToPrint(res.data.id);
  } catch (e) {
    showError(e);
  }
}

function organizeData() {
  formData.company_id = props.companyId;
  formData.bill_number = voucher.value.prefix + '-' + voucher.value.serial;
  formData.date = getCurrentDate(new Date());
  formData.item_details = data.value;
  formData.contact_profile_id = props.contactProfileId;
  formData.location_id = props.locationId;
  formData.adjustment_amount = discountAmount.value;
  formData.discount_amount = discountAmount.value;
  formData.discount_percent = discountPercent.value;
  formData.payment = grandTotal.value;
}

async function getVoucher() {
  voucher.value = await generateTxnNumber(`?company_id=${props.companyId}&voucher_type=journal_voucher&txn_type=invoice_journal`);
}

function addItem(item) {
    let alreadyExist = false;
    let dtIndex = -1;
    data.value.map((el, index) => {
        if(el.product_id === item.id) {
            alreadyExist = true;
            dtIndex = index;
        }   
    })

    if( alreadyExist ) {
        const existingItem = data.value[dtIndex];
        existingItem.quantity += 1;
        changeQty(existingItem.quantity, dtIndex);
        return;
    }

    const product = { name: item.name };
    let newItem = {
        ...item,
        quantity: 1,
        rate: item.description ? item.description.sales_price : 0,
        product,
        product_id: item.id,
        discount_amount: 0,
        discount_percent: 0,
        description: '',
        vat: 0,
        vat_amount: 0
    };
    newItem = { ...newItem, amount: totalAmount.value, total_amount: totalAmount.value };
    data.value.push(newItem);
}   

function deleteTableItem(index) {
  data.value.splice(index, 1);
}

function getProducts(id = -1) {
  products.value = [];
  props.items.forEach(item => (id === -1 ? getData(item) : (id === item.id && getData(item))));
}

function getData(item) {
  item.child && item.child.length ? item.child.forEach(ch => getData(ch)) : item.type === 'endpoint' && products.value.push(item);
}

function onPageChange(page) {
  const routeQuery = { ...route.query, page };
  router.push({ path: route.path, query: routeQuery });
  getProducts();
}

function changeQty(quantity, index) {
  if (quantity !== 0 && quantity !== '') {
    data.value[index].amount = data.value[index].rate * quantity;
    data.value[index].total_amount = data.value[index].rate * quantity;
  }
}

function getCurrentDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

async function getAccountData() {
    const companyQuery = `?company_id=${props.companyId}`;
    Promise.all([
        rest.fetchAccountReceivable(companyQuery).then(res=> {
            if(res.data) {
                accountRecHead.value = res.data;
                formData.account_head_id = res.data[0].id;
            } 
        }),
        rest.getAccountHeadBySlag("discount_account", companyQuery).then(res => {
            if(res.data) {
                discountAccHead.value = res.data;
                formData.discount_head_id = res.data[0].id;
                formData.discount_account_head_id = res.data[0].id;
            } 
        }),
        fetchCompanyInfo(props.companyId).then(res=> {
            if(res.data) companyInfo.value = res.data;
        }),
        fetchCashAndBank(props.companyId).then(res => {
            if (res.data) {
                cashAndBank.value = res.data
                formData.mop_account_head_id = res.data[0].id
            } 
        })
    ]).catch((e) => console.log(e))
}

function goToPrint(id) {
  resetForm();
  emit('resetIds');
  const pdf = pdfPrinter();
  const barcodeHandler = handleBarcode();
  const date = figureFormatter();
  let invoiceRes = {};
  const user = store.state.user.user;
  const companyQuery = `?company_id=${props.companyId}`;

  fetchSalesBill(id, companyQuery).then(res => {
    invoiceRes = res.data;
    const qrcodeData = JSON.stringify({
      ref_no: invoiceRes.bill_number,
      ref_date: invoiceRes.date,
      created_by: user.name,
      created_date_time: date.formatDate(new Date())
    });
    const barcodeQuery = `?code=${invoiceRes.bill_number}&qrcode=${qrcodeData}`;
    barcodeHandler.fetchBarcode(barcodeQuery).then(res => {
      pdf.exportToPDF(companyInfo.value, invoiceRes, res.barcode, res.qrcode, user.name, 1);
    });
  });
}

function resetForm() {
  data.value = [];
  discountAmount.value = 0;
  discountPercent.value = 0;
  Object.assign(formData, {
    ...formData,
    company_id: null,
    contact_profile_id: null,
    account_head_id: accountRecHead.value[0].id,
    mop_account_head_id: cashAndBank.value[0].id,
    business_id: null,
    project_id: null,
    cost_centre_id: null,
    location_id: null,
    status: 'active',
    bill_number: '',
    date: '',
    has_item_detail: true,
    description: '',
    order_number: null,
    sales_person_id: null,
    commission_percent: null,
    lc_number: null,
    discount_amount: 0,
    discount_percent: 0,
    discount_head_id: discountAccHead.value[0].id,
    discount_account_head_id: discountAccHead.value[0].id,
    vat_amount: 0,
    sale_type: 'pos_invoice',
    receipt_type: 'pos_invoice',
    item_details: [{
      product_id: null,
      name: '',
      description: '',
      quantity: 1,
      rate: 0,
      discount_percent: 0,
      vat: 0,
      sub_total: 0,
      discount_amount: 0,
      vat_amount: 0,
      total: 0,
      is_edit: false,
    }]
  });
}

async function getProductById(id) {
  const handler = handlePurchase();
  const companyQuery = `?company_id=${props.companyId}`;
  try {
    const res = await handler.fetchProductByProductId(id, companyQuery);
    if (! res.status ) {
      showError(res.message);
      return;
    }
    addItem(res.data);
    emit('resetIds');
  } catch (e) {
    console.log(e);
  }
}

const totalAmount = computed(() => {
  return data.value.reduce((total, item) => total + item.rate * item.quantity, 0).toFixed(2);
});

const grandTotal = computed(() => (totalAmount.value - discountAmount.value).toFixed(2));

watch(() => props.productId, (newVal) => newVal && getProductById(newVal));

watch(discountPercent, () => {
    if(discountPercent.value === 0){
        return discountAmount.value = 0;
    } 
    return discountAmount.value = (totalAmount.value * discountPercent.value) / 100;
})

watch(discountPercent, () => {
    if(discountPercent.value === 0){
        return discountAmount.value = 0;
    } 
    return discountAmount.value = (totalAmount.value * discountPercent.value) / 100;
})
</script>


<style scoped>
    .image-width{
        width: 80px;
    }
    .mb-20{
        margin-bottom: 20px;
    }
    .pay{
        border-top: 1px solid;
        border-bottom: 1px solid;
        background: #f3f2f7;
    }
</style>